import styled from 'styled-components';

export const CustomStylesContainer = styled.div`
  ${({ customStyles }) => customStyles}
`;

export const ClientBasedAuthPageMainContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100dvh;
  @supports not (height: 100dvh) {
    height: 100vh;
  }
`;
